export default __webpack_public_path__ + "static/media/3.f884ce6b.png";